.element {
  box-sizing: border-box;
  padding: 10px;
  margin: 20px 10px;
  border: 1px solid #cfcfcf;
  background: #eeeeee;
  z-index: 999;
  border-radius: 2px;
}
.dragging {
  border: 1px dashed #ccc;
  background: #fff;
}
.label {
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 5px;
}